import { memo } from "react";
import { UI_ModuleDocuments } from "./UI_ITOModuleDocuments";

const UI_MemoizedModuleDocuments = memo(UI_ModuleDocuments);

export default UI_MemoizedModuleDocuments;
